import React from "react"
import { useEffect } from "react"
import { useState } from "react"
import { Link } from "react-router-dom"
import Dashboard from "../../FirmwaresBlock/Dashboard"
import NavbarBlock from "../../Blocks/NavbarBlock/NavbarBlock"
import './Firmwares.scss'

export default function Firmwares({ token, onLogout }) {
    const [appState, setAppState] = useState({ loading: false })
    const [data, setData] = useState([])
    const [page, setPage] = useState(1)

    const getFirmwares = () => {
        let accesToken = localStorage.getItem('accesToken')
        let AuthStr = 'Bearer ' + accesToken
        const requestOptions = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': AuthStr
            }
        };
        fetch(`https://apiv1.zis.ru/sw-versions`, requestOptions)
            .then(response => response.json())
            .then(result => {
                setData(result)
            })
    }

    useEffect(() => {
        let accesToken = localStorage.getItem('accesToken');
        if (!accesToken) {

            window.location.href = '/'
            return false;
        }

        getFirmwares()
    }, [])

    console.log(data)

    return (
        <div className="container_firmwares">
            <NavbarBlock token={token} onLogout={onLogout} />
            <div className="container_firmwares_rightPart" >
                <h3>Firmwares</h3>
                <Dashboard data={data} />
                <Link
                    to='/new-firmware'
                >
                    <button>
                        <p>Add new</p>
                    </button>
                </Link>
            </div>
        </div>
    )
}
